var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 40C70 56.5685 56.5685 70 40 70C23.4315 70 10 56.5685 10 40C10 23.4315 23.4315 10 40 10C56.5685 10 70 23.4315 70 40ZM15 40C15 53.8071 26.1929 65 40 65C53.8071 65 65 53.8071 65 40C65 26.1929 53.8071 15 40 15C26.1929 15 15 26.1929 15 40Z",
    fill: "#23B9E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 30C45.8211 30 47.5 28.3211 47.5 26.25C47.5 24.1789 45.8211 22.5 43.75 22.5C41.6789 22.5 40 24.1789 40 26.25C40 28.3211 41.6789 30 43.75 30Z",
    fill: "#9CDFF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5008 60C35.9014 60 34.7133 58.519 35.0603 56.9577L39.4003 37.4274C38.3096 37.1586 37.5008 36.1737 37.5008 35C37.5008 33.6193 38.62 32.5 40.0008 32.5H42.5007C44.1001 32.5 45.2882 33.981 44.9412 35.5423L40.6012 55.0726C41.6919 55.3414 42.5007 56.3263 42.5007 57.5C42.5007 58.8807 41.3815 60 40.0008 60H37.5008Z",
    fill: "#9CDFF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9708ee25ab1d5fbb8d06f2a214404733.svg";
export { ForwardRef as ReactComponent };